var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainView"},[_c('headerView',{staticClass:"header",attrs:{"currentMenu":"ancient"}}),_c('div',{staticClass:"header-bg-div"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.libraryTitle))]),_c('menuView'),_c('div',{staticClass:"content"},[_c('leftCategory',{ref:"leftCategory"}),_c('contentView',{ref:"contentView"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }